

<template>
  <footer class="w-full absolute inset-x-0 bottom-0" aria-labelledby="footer-heading">
    <h2 id="footer-heading" class="sr-only">Footer</h2>
    <div class="w-full py-3 px-4">
      
      <div class="flex justify-center pr-0 sm:justify-end sm:pr-20 items-center gap-2">
  <div class="flex items-center my-auto mr-4">
    <router-link 
      v-if="$route.meta.title != 'About'" 
      to="/about" 
      class="mx-auto text-white transition ease-in-out delay-150 hover:scale-110 duration-100"
    >
      Learn more about DNSC-AKRED
    </router-link>
    <router-link 
      v-if="$route.meta.title === 'About'" 
      to="/login" 
      class="mx-auto text-white transition ease-in-out delay-150 hover:scale-110 duration-100"
    >
      Go back
    </router-link>
  </div>

  <img 
    class="h-14 w-auto object-contain" 
    src="../../assets/bagong_pilipinas_logo.png" 
    alt="Bagong Pilipinas"
  />
  <img 
    class="h-14 w-auto object-contain" 
    src="../../assets/dnsc_logo.png" 
    alt="DNSC Logo"
  />
  <img 
    class="h-14 w-auto object-contain ml-2 cursor-pointer" 
    src="../../assets/corseal.png" 
    alt="Corseal" 
    @click="openModal"
  />
</div>
      
    
    </div>
  </footer>

  <!-- Modal -->
<transition name="zoom">
  <div
    v-if="isModalOpen"
    class="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4"
    @click.self="closeModal"
  >
    <div
      class="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl shadow-xl w-full max-w-3xl md:max-w-5xl p-4 md:p-6 relative overflow-auto"
    >
      <!-- Close Button -->
      <button
        class="absolute top-2 right-3 text-white/70 hover:text-white text-xl"
        @click="closeModal"
      >
        ✕
      </button>

      <!-- Title -->
      <h2 class="text-lg font-semibold text-white text-center md:text-left mb-4">
        Certification of Registration
      </h2>

      <!-- Content -->
      <div class="flex flex-col md:flex-row items-center justify-center gap-4">
        <!-- Certificate -->
        <img
          src="@/assets/registration.jpg"
          alt="Certificate"
          class="w-full md:w-3/4 max-h-[400px] md:max-h-[530px] object-contain border border-white/20 rounded-lg"
        />

        <!-- Corseal -->
        <img
          src="@/assets/corseal.png"
          alt="Corseal"
          class="w-1/2 md:w-1/3 max-h-[200px] md:max-h-[400px] object-contain"
        />
      </div>
    </div>
  </div>
</transition>
</template>

<script>
export default{
  data(){
    return{
      isModalOpen : false,
    }
  },
  methods:{
    openModal() {
      this.isModalOpen = true
    },
    closeModal() {
      this.isModalOpen = false
    },
  }
}
</script>

<style scoped>
/* Overlay fade */
.zoom-enter-active,
.zoom-leave-active {
  transition: opacity 0.25s ease;
}

/* START (hidden state) */
.zoom-enter-from,
.zoom-leave-to {
  opacity: 0;
}

/* SAME transform for both (this is the key) */
.zoom-enter-from > div,
.zoom-leave-to > div {
  transform: scale(0.85);
}

/* END (visible state) */
.zoom-enter-to,
.zoom-leave-from {
  opacity: 1;
}

.zoom-enter-to > div,
.zoom-leave-from > div {
  transform: scale(1);
}

/* Smooth transform */
.zoom-enter-active > div,
.zoom-leave-active > div {
  transition: transform 0.25s ease;
}
</style>
